import React, { createContext, useState, useContext, useCallback } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({
    _id: `guest-${Date.now()}`,
    name: 'FutureLabGalaxy Teacher',
    email: 'teacher@FutureLabGalaxy.local',
    avatar: ''
  });
  const [loading] = useState(false);

  const updateUser = useCallback((nextUser) => {
    setUser(nextUser || {
      _id: `guest-${Date.now()}`,
      name: 'FutureLabGalaxy Teacher',
      email: 'teacher@FutureLabGalaxy.local',
      avatar: ''
    });
  }, []);

  const value = {
    user,
    loading,
    updateUser,
    isAuthenticated: true
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
